import React from 'react'
import './BrandingCard.css'

function BrandingCards() {
  return (
   <>
  <div>
            <div class="ag-format-container">
                <div class="ag-courses_box">
                    <div class="ag-courses_item">
                        <div href="#" class="ag-courses-item_link">
                            <div class="ag-courses-item_bg"></div>

                            <div class="ag-courses-item_title">
                                <h4 className='fw-bold'>Unique Total Branding Package</h4>
                                <p>Every business is unique and that’s how we see you. So that’s how we’ll handle working on your identity as a brand---with utmost care and of course, high level of professionalism.
    </p>
    <p>We just won’t go matching you with a designer, that’s too impersonal! With BrandCurb, you will work with a pool of our experts so that as a team, we can create a perfect branding package suited for your business. We believe in collaborative effort, that’s BrandCurb as a team.</p>
                            </div>


                        </div>
                    </div>

                    <div class="ag-courses_item">
                        <div class="ag-courses-item_link">
                            <div class="ag-courses-item_bg"></div>

                            <div class="ag-courses-item_title">
                                <h4 className='fw-bold'>Collaboration is Key</h4>
                               <p>There’s no perfect design for all, but a perfect design for one. We take branding seriously at BrandCurb because it’s the foundation of our work---that is why our pool of experts will be at your disposal in creating your custom graphic design requirements.
</p>
<p>Oh and not to brag, but a couple of varied proposals from different artists will be available to you in just 8 days. Yes, just a week and one day.
After you select which one you prefer, we’ll go ahead and refine that design to make it the one for you.</p>
                            </div>


                        </div>
                    </div>



                    <div class="ag-courses_item">
                        <div class="ag-courses-item_link">
                            <div class="ag-courses-item_bg"></div>

                            <div class="ag-courses-item_title">
                                <h4 className='fw-bold'>Collaboration is Key</h4>
                               <p>There’s no perfect design for all, but a perfect design for one. We take branding seriously at BrandCurb because it’s the foundation of our work---that is why our pool of experts will be at your disposal in creating your custom graphic design requirements.
</p>
<p>Oh and not to brag, but a couple of varied proposals from different artists will be available to you in just 8 days. Yes, just a week and one day.
After you select which one you prefer, we’ll go ahead and refine that design to make it the one for you.</p>
                            </div>


                        </div>
                    </div>

                    




                </div>
            </div>
        </div>
   
   
   
   </>
  )
}

export default BrandingCards